import { render, staticRenderFns } from "./CDRQComments.vue?vue&type=template&id=755e4b8e&scoped=true&"
import script from "./CDRQComments.vue?vue&type=script&lang=ts&"
export * from "./CDRQComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e4b8e",
  null
  
)

export default component.exports